///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {

    export class ReportUsersNonEmployeesCollection extends ReportEmployeesCollection {

        protected get url() {
            return 'report/User';
        }
    }

}
